var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./styles.scss";
import { useEffect, useState } from "react";
import { favoriteCookieService } from "@services/favorites/favorite-cookie-service";
var FavoriteToggle = function (_a) {
    var id = _a.id, modifierClass = _a.modifierClass;
    var _b = __read(useState(false), 2), isSelected = _b[0], setIsSelected = _b[1];
    var handleFavoriteToggle = function (id) {
        var favorites = favoriteCookieService.get();
        if (favoriteCookieService.has(id, favorites)) {
            favoriteCookieService.remove(id, favorites);
            setIsSelected(false);
            return;
        }
        favoriteCookieService.set(id, favorites);
        setIsSelected(true);
    };
    useEffect(function () {
        var favorites = favoriteCookieService.get();
        var isSelectedOnMount = favoriteCookieService.has(id, favorites);
        setIsSelected(isSelectedOnMount);
    }, [id]);
    if (!id)
        return null;
    var lang = document.documentElement.lang;
    var dictionary = {
        add: "Add",
        remove: "Remove",
        favorite: "favorite",
    };
    if (lang === "da") {
        dictionary.add = "Tilføj";
        dictionary.remove = "Fjern";
        dictionary.favorite = "favorit";
    }
    return (_jsxs("button", __assign({ className: "favorite-toggle" + (isSelected ? " favorite-toggle--is-selected" : "") + (modifierClass ? " " + modifierClass : ""), onClick: function () { return handleFavoriteToggle(id); } }, { children: [_jsx("svg", __assign({ className: "favorite-toggle__icon", role: "presentation", xmlns: "http://www.w3.org/2000/svg", viewBox: "-50 0 612 512" }, { children: _jsx("path", { fill: "currentColor", d: "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" }, void 0) }), void 0), _jsxs("span", __assign({ className: "sr-only", "aria-live": "polite" }, { children: [isSelected ? dictionary.remove : dictionary.add, " ", dictionary.favorite] }), void 0)] }), void 0));
};
export { FavoriteToggle };
